export default __webpack_public_path__ + "static/media/inst-icon.c09e6fc0.svg";